<script setup lang="ts">
export interface IconCard {
  fill?: string;
  width?: number;
  height?: number;
}
const props = withDefaults(defineProps<IconCard>(), { fill: "#1CB665", width: 20, height: 18 });
</script>

<template>
  <svg :width="props.width" :height="props.height" viewBox="0 0 94 88" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
      <rect fill="var(--base-icon-color)" width="94" height="88" rx="1.767" />
      <rect fill="var(--base-background-color)" x="8" y="8" width="78" height="36" rx="2" />
      <g transform="translate(8 52)" fill="var(--base-background-color)">
        <circle cx="6" cy="6" r="6" />
        <rect x="16" y="3" width="58" height="6" rx=".883" />
      </g>
      <g transform="translate(8 68)" fill="var(--base-background-color)">
        <circle cx="6" cy="6" r="6" />
        <rect x="16" y="3" width="45" height="6" rx=".883" />
      </g>
    </g>
  </svg>
</template>
